export default "__VITE_ASSET__Y6vsJLYK__"